module.exports = __webpack_public_path__ + "img/img_ticket_empty.eac078e2.png";